import { useField } from "formik";
import PropTypes from "prop-types";
import { RadioIcon } from "app/icons/controls";
import "./Radio.scss";
import classNames from "classnames";

export const Radio = ({
	name,
	value,
	id: idProp,
	children,
	onChange,
	className,
	inputClassName,
	labelClassName,
	...props
}) => {
	const [field, , helpers] = useField(name);
	const generatedId = crypto.randomUUID();

	const currentValues = [].concat(field.value ?? []);
	const checked = currentValues.includes(value);

	const id = idProp || `${name}--${value}--${generatedId}`;

	const rootClassNames = classNames("radio-component", {
		[className]: className,
	});

	const inputClassNames = classNames("radio-component__input", {
		[inputClassName]: inputClassName,
	});

	const labelClassNames = classNames("radio-component__label", {
		[labelClassName]: labelClassName,
	});

	const handleChange = (name, value) => {
		if (onChange) {
			onChange(name, value);
		}

		helpers.setValue([value]);
	};

	return (
		<div className={rootClassNames}>
			<input
				type="radio"
				id={id}
				name={name}
				checked={checked}
				onChange={() => handleChange(name, value)}
				onBlur={field.onBlur}
				className={inputClassNames}
				{...props}
			/>

			<label htmlFor={id} className={labelClassNames}>
				<RadioIcon checked={checked} aria-hidden={true} />

				{children}
			</label>
		</div>
	);
};

Radio.propTypes = {
	name: PropTypes.string.isRequired,
	value: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	onChange: PropTypes.func,
	className: PropTypes.string,
	inputClassName: PropTypes.string,
	labelClassName: PropTypes.string,
};
